// React and related imports
import React from 'react';

// Flowbite components
import { Button } from 'flowbite-react';

// i18 hooks
import { useTranslation } from 'react-i18next';

// Redux selectors, hooks, and actions
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../../redux/selectors/displaySettingsSelectors';

interface EditButtonProps {
  onClick: () => void;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  const isDarkMode = useAppSelector(selectIsDarkMode);
  const buttonClassName = `btn ${isDarkMode ? 'btn-dark' : 'btn-light'}`;

  return (
    <Button size="xs" className={`m-auto ${buttonClassName}`} onClick={onClick}>
      {t('contentContext.edit')}
    </Button>
  );
};
